<template>

    <div>

      <vx-card class="mt-4">
        <!-- SEARCH BAR -->
        <vs-row vs-type="flex" >
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" >
            <label>Data do portfolio</label>
            <vs-select
              v-model="portfolio"
              class="w-full">
              <vs-select-item :key="index" :value="item.portfolioDate" :text="item.portfolioDate" v-for="(item, index) in portfolios" />
            </vs-select>
          </vs-col>

          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" vs-align="center" class="mt-4">
            <vs-row vs-align="center" >
              <vs-col vs-lg="5" vs-sm="5" vs-xs="12" vs-type="flex" class="mt-1">
                <vs-button class="w-full" @click="refine(portfolio)" icon="search">Buscar</vs-button>
              </vs-col>

              <vs-col vs-lg="2" vs-sm="2" vs-xs="12" class="mt-1">
                <button name="button" @click="openPrompt"
                  class="vs-component vs-button vs-button-primary vs-button-filled includeIcon includeIconOnly vs-radius">
                  <feather-icon icon="PlusIcon" svgClasses="w-4 h-4"></feather-icon>
                </button>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>

      </vx-card>

      <vx-card class="mt-4">

        <vs-table stripe :data="guaranteeFiles" noDataText="Nenhum registro encontrado.">

          <template slot="thead">
            <th>File Name</th>
            <th>Data do Portfolio</th>
            <th>Usuário</th>
            <th>Data de Upload</th>
            <th></th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(row, indextr) in data">
              <td>
                <a role="button" style="cursor: pointer" @click="view(row.guid)">{{row.fileName}}</a>
              </td>
              <td>
                {{row.portfolio.portfolioDate | formatDate}}
              </td>
              <td>
                {{row.createdByStr}}
              </td>
              <td>
                {{row.createdAt | formatDate}}
              </td>
              <td>
                <a role="button" style="cursor: pointer" @click="del(row.guid)">apagar</a>
              </td>
            </vs-tr>
          </template>

        </vs-table>

        <div class="my-5">
          <vs-pagination
            v-model="page"
            :total="totalPages">
          </vs-pagination>
        </div>

      </vx-card>

      <div class="vx-row mt-4">
        <div class="vx-col">
          <vs-button @click="downloadTemplate">Download Template</vs-button>
        </div>

        <div class="vx-col">
          <vs-button @click="openPrompt">Adicionar Garantias</vs-button>
        </div>
      </div>

      <vs-prompt
        @accept="addGuarantee"
        @close="close"
        title="Novo Portfolio"
        accept-text="Adicionar"
        :active.sync="activePrompt">
        <div class="grid grid-rows-2 gap-2">

          <div>
            <label>Portfolio</label>
            <vs-select
              v-model="portfolioGuid"
              autocomplete
              class="w-full">
              <vs-select-item :key="index" :value="item.guid" :text="item.portfolioDate" v-for="(item, index) in portfolios" class="w-full"/>
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('data do portfolio')">{{ errors.first('data do portfolio') }}</span>
          </div>

          <div class="mt-4">
            <label class="file-select">
              <div class="select-button">
                <span v-if="file">Arquivo selecionado: {{file.name}}</span>
                <span v-if="file === ''" class="vs-component vs-button vs-button-primary vs-button-filled">Selecione um arquivo</span>
              </div>
              <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
            </label>
          </div>

        </div>
      </vs-prompt>

      <vs-prompt
        @close="close"
        title="Log de Upload"
        accept-text="OK"
        :active.sync="activeLogPrompt">
        <vs-table stripe :data="guaranteeLogs" noDataText="Nenhum registro encontrado.">

          <template slot="thead">
            <th>Descrição</th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(row, indextr) in data">
              <td>
                {{row.description}}
              </td>
            </vs-tr>
          </template>

        </vs-table>
      </vs-prompt>

      <vs-prompt
        @accept="deleteGuarantee"
        @close="close"
        title="Atenção"
        accept-text="Sim"
        :active.sync="activeDeletePrompt">
          <span>Deseja apagar?</span>
      </vs-prompt>

    </div>

</template>

<script>
import axios from 'axios'
import portfolioList from "@/mixins/Portfolio"
import NumericInput from "@/components/NumericInput"

export default {
  name: "GuaranteeAdd",
  mixins:[portfolioList],
  components:{
    NumericInput
  },
  data () {
    return {
      activePrompt: false,
      activeLogPrompt: false,
      activeDeletePrompt: false,
      portfolio: null,
      guaranteeFiles: [],
      guaranteeLogs: [],
      delGuid: null,
      file: '',
      page: 1,
      totalPages: 0,
    }
  },
  beforeMount () {
    this.loadGuaranteeFiles()
  },
  methods: {

    close () {
      this.activeLogPrompt = false
    },

    refresh () {
      this.loadGuaranteeFiles()
    },

    openPrompt () {
      this.activePrompt = true
    },

    addGuarantee () {
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('portfolioGuid', this.portfolioGuid)
      axios.post(`${process.env.VUE_APP_API}/api/v1/guarantee/excel`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        this.valueResponse = response.data
      })
        .finally(()=>{
          this.file = ''
          this.loadGuaranteeFiles()
        })
    },

    loadGuaranteeFiles () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/guaraantee-file`, {
        params: {
          portfolioGuid: this.portfolioGuid
        }
      })
      .then((response) => {
        this.guaranteeFiles = response.data.content
        this.totalPages = response.data.totalPages
      })
    },

    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },

    view (guid) {
      this.activeLogPrompt = true
      axios.get(`${process.env.VUE_APP_API}/api/v1/guaraantee-file/${guid}`)
      .then((response) => {
        this.guaranteeLogs = response.data
      })
    },

    refine ( idThunders, portfolio) {
      this.portfolio = portfolio
      this.page = 1
      this.refresh()
    },

    downloadTemplate () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/guarantee/excel/template`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },

    del(guid) {
      this.delGuid = guid
      this.activeDeletePrompt = true
    },

    deleteGuarantee () {
      this.activeDeletePrompt = false
      axios.delete(`${process.env.VUE_APP_API}/api/v1/guarantee/upload/${this.delGuid}`)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            text: 'Garantias apagadas'
          })
        })
        .finally(() => {
          this.loadGuaranteeFiles()
          this.delGuid = null
        })

    }

  }
}
</script>

<style scoped>
/* Don't forget to hide the original file input! */
.file-select > input[type="file"] {
  display: none;
}
</style>
